import DefaultProps from '../../commonTypes/defaultprops.types';
import Handler from '../../commonTypes/handler.types';
import { MLBTheme } from '../../style/theme.types';

export enum TagStyles {
  DEFAULT = 'default',
  LINK_BLUE = 'link-blue',
  TICKET_LINK_GREEN = 'ticket-link-green',
  MLB_TV_ORANGE = 'mlb-tv-orange',
  TEAM = 'team',
  LINK_BLUE_DARK = 'link-blue-dark'
}

export interface TagProps extends DefaultProps {
  label?: string;
  color?: TagStyles;
  hasRemoveButton?: Boolean;
  handlers?: Handler;
  highlightColor?: Boolean;
}

export interface IndividualTagColors {
  color: string;
  backgroundColor: string;
  hoverBackgroundColor?: string;
}

export interface PropTypes {
  theme: MLBTheme;
  color: TagStyles;
  hasRemoveButton?: Boolean;
  highlightColor?: Boolean;
};

interface LightButtonShape {
  disabled?: IndividualTagColors;
  default?: IndividualTagColors;
  linkBlue?: IndividualTagColors;
  ticketGreen?: IndividualTagColors;
  mlbTvOrange?: IndividualTagColors;
  linkBlueOnDark?:IndividualTagColors;
}

interface DarkButtonShape {
  disabled?: IndividualTagColors;
  default?: IndividualTagColors;
  linkBlue?: IndividualTagColors;
  ticketGreen?: IndividualTagColors;
  mlbTvOrange?: IndividualTagColors;
}

export interface IndividualTagColorShape {
  linkBlueOnDark: IndividualTagColors;
}

export interface TagColorsShape {
  dark: DarkButtonShape;
  light: LightButtonShape;
}
